import axios from "axios";
import {notify} from "@kyvg/vue3-notification";

export default {
    namespaced: true,

    state: () => ({
        taskList: [],
        colorList: [],
        recordList: [],
    }),

    mutations: {
        setTaskList(state, data) {
            state.taskList = data?.data;
        },
        setColorList(state, data) {
            state.colorList = data;
        },
        setRecordList(state, data) {
            state.recordList = data;
        },
    },

    actions: {
        async getTasks({ commit }) {
            await axios.get(`public/mood_tracker/tasks`).then(({ data }) => {
                commit("setTaskList", data);
            });
        },
        async getColors({ commit }) {
            await axios.get(`public/mood_tracker/colors`).then(({ data }) => {
                commit("setColorList", data);
            });
        },
        async getRecords({ commit }) {
            await axios.get(`mood_tracker/list`).then(({ data }) => {
                commit("setRecordList", data);
            });
        },
        async createRecord({ commit }, data) {
            await axios.post(`mood_tracker/create`, data).then(() => {
                notify({
                    title: "Запись сохранена",
                    type: "success",
                });
            });
        },
        async submitFeedback({ commit }, data) {
            await axios.post(`mood_tracker/${data.id}/feedback`, data.form).then(() => {
                notify({
                    title: "Запись сохранена",
                    type: "success",
                });
            });
        },
    }
}
